import {
  config
} from '../_config';
import {
  authHeader,
  handleResponse
} from '../_helpers';

export const dogService = {
  createUserDog,
  updateUserDog,
  deleteUserDog,
  getDogBreeds,
  getDogBooks,
  getUserDog,
  createCriador,
  updateCriador,
  deleteCriador,
  createCopropietario,
  updateCopropietario,
  deleteCopropietario,
  getAllDogTitles,
  insertDogTitle,
  deleteDogTitle,
  stBuscarPerroChip
}

/* FUNCIONES PARA GESTION DE LOS CRIADORES */

function createCriador(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(datos)
  };
  return fetch(`${config.apiUrl}/breeders`, requestOptions).then(handleResponse);
}

function updateCriador(datos) {

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(datos)
  };
  console.log(datos)
  return fetch(`${config.apiUrl}/breeders/${datos.id}`, requestOptions).then(handleResponse);

}

function deleteCriador(id) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
  };

  return fetch(`${config.apiUrl}/breeders/${id}`, requestOptions).then(handleResponse);

}

/* 
  FUNCIONES COPROPIETARIOS

*/

function createCopropietario(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(datos)
  };
  return fetch(`${config.apiUrl}/cowners`, requestOptions).then(handleResponse);
}

function updateCopropietario(datos) {

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(datos)
  };
  console.log(datos)
  return fetch(`${config.apiUrl}/cowners/${datos.id}`, requestOptions).then(handleResponse);

}

function deleteCopropietario(id) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
  };

  return fetch(`${config.apiUrl}/cowners/${id}`, requestOptions).then(handleResponse);

}


/**
 * function para crear un registro de un perro de usuario
 * 
 * @param {Object} objDog 
 */
function createUserDog(objDog) {


  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(objDog)
  };

  return fetch(`${config.apiUrl}/dogs`, requestOptions).then(handleResponse);

}

/**
 * funcion para editar un registro de un perro
 * 
 * @param {Object} objDog 
 */
function updateUserDog(datos) {

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(datos)
  };

  return fetch(`${config.apiUrl}/dogs/${datos.objDog.id}`, requestOptions)
    .then(handleResponse)
    .then(response => {
      //refreshUserData();
      return response;
    })

}

/**
 * funcion para eliminar un perro de usuario - soft delete
 * 
 * @param {Object} objDog 
 */
function deleteUserDog(objDog) {

  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/dogs/${objDog.id}`, requestOptions).then(handleResponse);

}

/**
 * funcion para recoger las razas de todos los perros - se guardan en localStorage dogBreeds
 * 
 */
function getDogBreeds() {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/breeds`, requestOptions)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('dogBreeds', JSON.stringify(response));
      return response;
    });

}

/**
 * funcion para recoger los libros de los perros - se guardan en localStorage dogBooks
 * 
 */

function getDogBooks() {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/books`, requestOptions)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('dogBooks', JSON.stringify(response));
      return response;
    })
}

function getUserDog(dogId) {

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  }

  return fetch(`${config.apiUrl}/dogs/${dogId}`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    })


}
/* FUNCION PARA CONSULTAR A LA API LA LISTA DE TITULOS */
function getAllDogTitles() {

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  }

  console.log(requestOptions)

  return fetch(`${config.apiUrl}/titleDog`, requestOptions)
    .then(handleResponse)

}

/* FUNCION PARA INSERTAR UN TITULO PARA UN PERRO */
function insertDogTitle(data) {
  console.log(data)
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(data)
  }

  return fetch(`${config.apiUrl}/titleDog`, requestOptions).then(handleResponse);

}

/* FUNCION PARA ELIMINAR UN TITULO DE UN PERRO */

function deleteDogTitle(data) {

  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
  };

  return fetch(`${config.apiUrl}/titleDog/${data.id}`, requestOptions).then(handleResponse);

}

/*  funcion para buscar un perro por chip y recuperar sus datos */
function stBuscarPerroChip(chip) {

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(chip)
  }

  return fetch(`${config.apiUrl}/findDogByChip`, requestOptions).then(handleResponse);


}